// biome-ignore lint/suspicious/noShadowRestrictedNames: Immutable.js Map/Set
import { fromJS, Map, Record } from 'immutable';
import simpleReducer from '../common/utils/simple-reducer.js';
import { getProjectWebhooks, updateProjectWebhooks } from './actions.js';

const emptyMap = Map();
export const emptyData = fromJS({
  secret: '',
  webhooks: [{}]
});

export const WebhooksState = Record({
  version: 0,
  data: emptyData,
  loading: false,
  loaded: false,
  saving: false
});

export const initialState = new WebhooksState();

function applyDefaults(result) {
  return emptyData.merge(fromJS(result).filter(Boolean));
}

function routineReducer(routine, { loadingProp, loadedProp }) {
  return {
    [routine.PENDING]: (state) => state.set(loadingProp, true),
    [routine.FULFILLED](state, { payload }) {
      const update = {
        data: applyDefaults(payload.result || emptyMap),
        version: state.version + 1,
        [loadingProp]: false
      };

      if (loadedProp) {
        update[loadedProp] = true;
      }

      return state.merge(update);
    },
    [routine.REJECTED]: (state) => state.set(loadingProp, false)
  };
}

export default simpleReducer(initialState, {
  ...routineReducer(getProjectWebhooks, {
    loadingProp: 'loading',
    loadedProp: 'loaded'
  }),
  ...routineReducer(updateProjectWebhooks, { loadingProp: 'saving' })
});
